import { IsBoolean, IsObject, IsString } from 'class-validator';
import { BoipaAuthorizationResponseDto } from './boipa-authorization-response.dto';

export class DigitalWalletPaymentResponseDto {
  @IsBoolean()
  success: boolean;

  @IsString()
  message?: string;

  @IsString()
  redirectionUrl?: string;

  @IsObject()
  result?: BoipaAuthorizationResponseDto;
}
